module.exports = __webpack_public_path__ + "0a8718c5eec4f271a51040222d010b49.jpg";